import { render } from "./Project3View.vue?vue&type=template&id=eaf8d46c&scoped=true"
import script from "./Project3View.vue?vue&type=script&lang=js"
export * from "./Project3View.vue?vue&type=script&lang=js"

import "./Project3View.vue?vue&type=style&index=0&id=eaf8d46c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eaf8d46c"]])

export default __exports__